// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import ReactTimeAgo from 'react-timeago';

class TimeAgo extends Component<any, any> {
    formatter(value: any, unit: any, suffix: any) {
        return unit === 'second' ? 'just now' : value + " " + unit + (value > 1 ? "s" : "") + " " + suffix;
    }

	render() {
		return (
            <ReactTimeAgo formatter={this.formatter} date={this.props.date}/>
		)
	}
}

export default TimeAgo;